
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ShareTestDialog } from "@/components/job/ShareTestDialog";
import { CheckCircle, Share2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { showSuccessToast } from "@/utils/toast-utils";

interface SuccessScreenProps {
  testId: string;
}

export const SuccessScreen = ({ testId }: SuccessScreenProps) => {
  const [showShareDialog, setShowShareDialog] = useState(true);
  const navigate = useNavigate();

  // Show a success toast when the component mounts
  useEffect(() => {
    showSuccessToast({
      title: "Test Published",
      description: "Your test has been published successfully!"
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full space-y-6 py-12 bg-background">
      <div className="text-center space-y-4">
        <CheckCircle className="w-16 h-16 mx-auto text-green-500" />
        <h1 className="text-3xl font-bold text-foreground">
          Congrats! Your test is published and ready to be shared!
        </h1>
        <p className="text-lg text-muted-foreground">
          Share your test with candidates so they can take the assessment.
        </p>
      </div>

      <Card className="w-full max-w-md p-6 bg-card text-card-foreground">
        <div className="space-y-4">
          <Button 
            className="w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground"
            onClick={() => setShowShareDialog(true)}
          >
            <Share2 className="mr-2 h-4 w-4" />
            Share Test
          </Button>
          
          <Button 
            className="w-full"
            onClick={() => navigate(`/test/${testId}/take`)}
          >
            Take Test (Preview)
          </Button>
          
          <div className="flex gap-4">
            <Button 
              className="w-full"
              variant="outline"
              onClick={() => navigate(`/test/${testId}`)}
            >
              View Test
            </Button>
            
            <Button 
              className="w-full"
              variant="outline"
              onClick={() => navigate('/test-management')}
            >
              Manage Tests
            </Button>
          </div>
        </div>
      </Card>

      <ShareTestDialog
        open={showShareDialog}
        onOpenChange={setShowShareDialog}
        testId={testId}
      />
    </div>
  );
};
